import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import { poemsApi } from '../services/api';

const PoemDetailPage = () => {
  const { id } = useParams();
  const [poem, setPoem] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    poemsApi.getById(id).then((data) => setPoem(data.poem)).catch((err) => setError(err.message));
  }, [id]);

  return (
    <Layout>
      <Seo title={poem?.title || 'قصيدة'} />
      <div className="container-responsive max-w-3xl py-16">
        {error && <p className="text-error-600">{error}</p>}
        {poem && (
          <article className="rounded-[2.2rem] border border-gold-500/25 bg-white px-8 py-14 text-center shadow-large dark:bg-stone-900">
            <p className="text-xs tracking-[0.3em] text-gold-600">قصيدة</p>
            <h1 className="mt-3 text-4xl font-bold">{poem.title}</h1>
            {poem.poet_name && (
              <p className="poet-name mt-4 text-2xl text-gold-700">الشاعر: {poem.poet_name}</p>
            )}
            {poem.martyr_id ? (
              <p className="mt-2 text-stone-500">
                في رثاء <Link className="underline" to={`/martyr/${poem.martyr_id}`}>{poem.martyr_name_ar}</Link>
              </p>
            ) : (
              <p className="mt-2 text-stone-500">قصيدة عامة</p>
            )}
            <div className="poem-verse my-10 border-y border-gold-500/20 py-10 text-2xl">{poem.content}</div>
            <Link to={poem.martyr_id ? `/poems?id=${poem.martyr_id}` : '/poems'} className="btn btn-outline">ديوان القصائد</Link>
          </article>
        )}
      </div>
    </Layout>
  );
};

export default PoemDetailPage;
